import { z } from 'zod';
/** Response of POST /api/v1/providers/:provider/events (OIP's own contract). */
export const providerIngestResponseSchema = z.object({
    accepted: z.boolean(),
    duplicate: z.boolean(),
    providerEventId: z.string(),
    processingStatus: z.enum([
        'RECEIVED',
        'QUEUE_PENDING',
        'QUEUED',
        'PROCESSING',
        'PROCESSED',
        'FAILED',
        'UNRESOLVED_REFERENCE',
    ]),
    correlationId: z.string().optional(),
});
//# sourceMappingURL=provider-ingest.js.map